import HomePage from "./Pages/HomePage.svelte"
import PrivacyPolicyPage from "./Pages/PrivacyPolicyPage.svelte"

export default {
    // Exact path
    '/': HomePage,
    '/politicas-de-privacidade': PrivacyPolicyPage,
}
